export const requiredPackageVersions = {
  "@plasmicapp/loader": "0.0.1",
  "@plasmicapp/cli": "0.1.342",
  "@plasmicapp/host": "1.0.211",
  "@plasmicapp/react-web": "0.2.404",
  "@plasmicapp/react-web-runtime": "0.0.1",
};
